import React from 'react';

const LoginLoader = ({ progress, text }) => {
  return (
    <div className="fixed inset-0 bg-slate-100/80 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl academic-shadow-lg max-w-md w-full text-center">
        <div className="text-5xl mb-6">📚</div>
        <h2 className="text-2xl font-bold text-slate-800 mb-4">
          Signing In...
        </h2>

        {/* Progress Bar */}
        <div className="w-full bg-slate-200 rounded-full h-4 mb-2 overflow-hidden border border-slate-300">
          <div
            className="bg-gradient-to-r from-blue-500 to-cyan-500 h-4 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Progress Text */}
        <p className="text-slate-600 h-5 transition-opacity duration-300">
          {text}
        </p>
      </div>
    </div>
  );
};

export default LoginLoader;
